<template>
  <div class="account_setting">
    <div class="account_info flex mar_bottom_20">
      <div class="account_label">手机账号：</div>
      <div class="account_value">
        <div class="account_text">绑定手机后可使用该手机号直接登录当前账号</div>
        <div class="account_active mar_top_12">{{ personalInfo.phone }}</div>
        <div class="flex mar_top_15">
          <!-- <div class="account_active mar_right_30 cursor_pointer" @click="unbindPhone">解绑</div> -->
          <div class="account_active mar_right_30 cursor_pointer" @click="verifyPassword">更换手机</div>
          <div
            class="account_active mar_right_30 cursor_pointer"
            @click="href('/passwordUpdate')"
          >
            {{personalInfo.passwordExists==0?'密码设置':'修改密码'}}
          </div>
        </div>
      </div>
    </div>
    <div class="account_info flex mar_bottom_20">
      <div class="account_label">实名认证：</div>
      <div class="account_value">
        <div class="flex Flexalign" v-if="!personalInfo.identity">
          <div class="account_text">未认证</div>
          <div class="account_text mar_left_20 active_text cursor_pointer" @click="href('/realNameVerify')">去认证</div>
        </div>
        <div v-else>已认证</div>
      </div>
    </div>
    <!-- <div class="account_info flex mar_bottom_20">
      <div class="account_label">第三方账号：</div>
      <div class="account_value">
        <div class="account_text">绑定后可使用以下账号直接登录当前账号</div>
        <div class="flex Flexalign mar_top_15">
          <div class="flex Flexalign third_party_box mar_right_30">
            <el-image class="weixin_active_icon" :src="iconPath('weixin_active_icon.png')"></el-image>
            <div class="account_active mar_left_10">小样爱学习</div>
          </div>
          <div class="flex Flexalign third_party_box mar_right_30">
            <el-image class="weixin_active_icon" :src="iconPath('weibo_gray_icon.png')"></el-image>
            <div class="account_text mar_left_10">
              微博 /<span class="account_active">绑定</span>
            </div>
          </div>
          <div class="flex Flexalign third_party_box mar_right_30">
            <el-image class="weixin_active_icon" :src="iconPath('qq_gray_icon.png')"></el-image>
            <div class="account_text mar_left_10">
              腾讯QQ /<span class="account_active">绑定</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="btn_cancel mar_top_30 cursor_pointer">注销账号</div> -->
    <unbind ref="unbind"></unbind>
    <verify ref="verify"></verify>
  </div>
</template>

<script>
import unbind from "@/components/popup/unbind.vue";
import verify from "@/components/popup/verify.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5AccountSetting",
  components: {
    unbind,
    verify,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },

  data() {
    return {
      personalInfo:{}
    };
  },

  mounted() {
    this.getUserInfo();
  },

  methods: {
    getUserInfo() {
      this.$Api.login.getUserInfo().then((response) => {
        this.personalInfo = response.data.data;
      });
    },
    unbindPhone() {
      this.$refs.unbind.unbindShow = true;
    },
    verifyPassword() {
      this.$refs.verify.verifyShow = true;
      this.$refs.verify.phone = this.personalInfo.phone;
    },
  },
};
</script>
<style lang="scss" scoped>
.mar_top_12 {
  margin-top: 12px;
}

.account_setting {
  .account_info {
    margin-top: 30px;

    .account_label {
      color: #333333;
      width: 120px;
      font-weight: 600;
    }

    .account_value {
      .account_name {
        color: #333333;
        font-weight: 600;
      }

      .account_text {
        line-height: 26px;
        font-size: 14px;
        color: #999999;
      }
      .active_text{
        color: #13d6aa;
      }

      .account_active {
        font-size: 16px;
        color: #13d6aa;
      }

      .weixin_active_icon {
        width: 34px;
        height: 34px;
      }
    }
  }

  .btn_cancel {
    width: 109px;
    height: 34px;
    border-radius: 17px;
    border: 1px solid #dddddd;
    color: #999999;
    text-align: center;
    line-height: 34px;
  }
}
</style>
